import lazyLoading from './lazyLoading';

export default {
  name: 'Transactions',
  meta: {
    expanded: false,
    title: 'schema.ec_transactions',
    iconClass: 'fa fa-dollar-sign',
    auth: ['admin', 'landlord'],
  },
  children: [
    {
      name: 'Transactions',
      path: '/ecommerce/transactions/:id?',
      component: lazyLoading('ecommerce/EC_Transactions'),
      meta: {
        title: 'schema.ec_transactions',
        iconClass: 'fa fa-exchange-alt',
        to: '/ecommerce/transactions',
        auth: ['admin', 'landlord'],
      },
      props: r => ({root: true, id: r.params.id}),
    },
    {
      name: 'Invoices',
      path: '/ecommerce/invoices/:id?',
      component: lazyLoading('ecommerce/EC_Invoices'),
      meta: {
        title: 'schema.ec_invoices',
        iconClass: 'fa fa-receipt',
        to: '/ecommerce/invoices',
        auth: ['admin', 'landlord'],
      },
      props: r => ({root: true, id: r.params.id}),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/transactions.js